module.exports = __webpack_public_path__ + "img/card-provider-compensatory-services.748c63db.svg";